import React, { useEffect, useState } from 'react';
import IconLinkExternal from '../IconLinkExternal';
import { $t } from './copywrite';

// -------------------------------------------------

export const LinkToOrderOrPayments = ({ lang, siteId, coexistenceEnabled }) => {
  if (!coexistenceEnabled) {
    return null;
  }

  /**
   * we have now two payment APIs: order | payments
   * when in order, we must show a solid item on the
   * sidebar showing the payments api possibility,
   * and when in payments, we must show the order
   * possibility. this component does it automatically.
   */
  const offerPaymentsButtonConfig = {
    docsPathname: 'checkout-api/landing#from=coexistence_sidebargotopayments_click',
    label: $t('Checkout API vía Pagos', siteId, lang),
    pathnames: [
      /\/checkout-api-v2\//,
      /\/checkout-api-orders\//,
    ],
  };

  const offerOrderButtonConfig = {
    docsPathname: 'checkout-api-v2/overview#from=coexistence_sidebargotoorders_click',
    label: $t('Checkout API vía Orders', siteId, lang),
    pathnames: [
      /\/checkout-api\//,
      /\/checkout-api-legacy\//,
    ],
  };

  // -------------------------------------------------

  const orderOrPayments = (currentPathname) => {
    if (typeof currentPathname !== 'string' || !currentPathname?.trim()) {
      return null;
    }

    if (offerPaymentsButtonConfig?.pathnames.some(regex => regex.test(currentPathname))) {
      return offerPaymentsButtonConfig;
    }

    if (offerOrderButtonConfig?.pathnames.some(regex => regex.test(currentPathname))) {
      return offerOrderButtonConfig;
    }

    return null;
  };

  const [config, setConfig] = useState(null);

  useEffect(() => {
    // must use an effect to allow the component to update the
    // component if an SPA-like change is made on the location
    if (typeof window !== typeof undefined) {
      const { pathname } = window.location;
      setConfig(orderOrPayments(pathname));
    }
  });

  return config && (
    <li className="link-to-order-or-payments">
      <a href={`/developers/${lang}/docs/${config.docsPathname}`} rel="noopener noreferrer">
        <span>{config.label}</span> <IconLinkExternal />
      </a>
    </li>
  );
};
